<section class="main-container impressum">
  <app-page-header [breadcrumbs]="breadCrumbs" [headerTitle]="'Impressum' | translate"></app-page-header>

  <div class="card impressum-list">
    <h2 translate>You can find our applicable documents here</h2>
    <ul>
      <li>
        <a href="https://admin.verein.cloud/content/imprint" target="_blank" translate>Impressum</a>
      </li>
      <li>
        <a href="https://admin.verein.cloud/content/conditions" target="_blank" translate>Terms and Conditions</a>
      </li>
      <li>
        <a href="https://admin.verein.cloud/content/nutzungsbedingungen" target="_blank" translate>Terms of Use</a>
      </li>
      <li>
        <a href="https://admin.verein.cloud/content/privacy" target="_blank" translate>Privacy Policy</a>
      </li>
    </ul>
  </div>
</section>
